module.exports = __webpack_public_path__ + "img/leftBottom.5d875f99.png";